import { createBrowserHistory } from 'history';

import { ROUTES } from '../constants';

// Single shared history instance for the whole app.
// In Jest, the URL is usually '/', so using a basename like '/fo' produces warnings.
const history = createBrowserHistory({
  basename: process.env.NODE_ENV === 'test' ? '/' : ROUTES.BASENAME,
});

export default history;
